import Office from "../assets/office.jpg";
import Library from "../assets/library.jpg";
import OfficeCeiling from "../assets/office_ceiling.jpg";
import PublicImage from "../assets/public.jpg";
import Background from "../assets/background.jpg";

export const MenuList = [
  {
    name: "Elegant POP Sculpted Ceiling",
    image: Office,
    description: "Gracefully sculpted POP ceilings that elevate every room with timeless elegance and modern finesse.",
    link: "/service/1",
  },
  {
    name: "Precision Gypsum Panel Ceiling",
    image: Library,
    description: "Precision‑cut gypsum panels for seamless ceilings that enhance acoustics, lighting, and modern aesthetics.",
    link: "/service/2",
  },
  {
    name: "Modern Louvered Wall Panels",
    image: OfficeCeiling,
    description: "Sleek louvered wall panels that blend texture, ventilation, and modern elegance for a refined architectural statement.",
    link: "/service/3",
  },
  {
    name: "AquaShield Moisture-Guard Ceiling",
    image: PublicImage,
    description: "Seal out humidity with a waterproof, mildew‑resistant ceiling built for kitchens, baths, and balconies.",
    link: "/service/4",
  },
  {
    name: "Laminated False Ceiling",
    image: Background,
    description: "Seamless laminated panels that deliver modern aesthetics, quick installation, and a wipe‑clean, long‑lasting surface.",
    link: "/service/5",
  },
];
